module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-16.def0919c.jpg";